var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userSignedIn)?_c('router-view'):(_vm.userSignInFailed)?_c('router-view',{attrs:{"name":"unauthorized"}}):(_vm.userNotSignedIn)?_c('router-view',{attrs:{"name":"loader"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }